// src/store/modules/filters.js
const state = {
    years: [],
    selectedYear: null,
};

const mutations = {
    SET_YEARS(state, years) {
        const uniq = Array.from(new Set(years)).sort((a, b) => b - a);
        state.years = uniq;
        if (!state.selectedYear && uniq.length) {
            const saved = localStorage.getItem('selectedYear');
            state.selectedYear = saved ? Number(saved) : uniq[0];
        }
    },
    SET_SELECTED_YEAR(state, year) {
        state.selectedYear = Number(year);
        localStorage.setItem('selectedYear', state.selectedYear);
    },
};

const actions = {
    initYears({ commit, state }, years) {
        if (state.years.length === 0) commit('SET_YEARS', years);
    },
    selectYear({ commit }, year) {
        commit('SET_SELECTED_YEAR', year);
    },
};

const getters = {
    years: s => s.years,
    selectedYear: s => s.selectedYear,
};

export default { namespaced: true, state, mutations, actions, getters };